export default __webpack_public_path__ + "static/ams-reveiw-tekrevol-hd-b1d1cb4e8cbf96755013f23a80f92d8d.mp4";